import { render, staticRenderFns } from "./WordList.vue?vue&type=template&id=8d9bc06c&scoped=true&"
import script from "./WordList.vue?vue&type=script&lang=js&"
export * from "./WordList.vue?vue&type=script&lang=js&"
import style0 from "./WordList.vue?vue&type=style&index=0&id=8d9bc06c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9bc06c",
  null
  
)

export default component.exports